module.exports = __webpack_public_path__ + "media/images/gymfinity-loho-278e351161707e680c3f63b8d8b6dc55.svg";